var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarSoS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    fill: "#5C61F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#5C61F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 12H25V11C25 10.7348 24.8946 10.4804 24.7071 10.2929C24.5196 10.1054 24.2652 10 24 10C23.7348 10 23.4804 10.1054 23.2929 10.2929C23.1054 10.4804 23 10.7348 23 11V12H17V11C17 10.7348 16.8946 10.4804 16.7071 10.2929C16.5196 10.1054 16.2652 10 16 10C15.7348 10 15.4804 10.1054 15.2929 10.2929C15.1054 10.4804 15 10.7348 15 11V12H13C12.2044 12 11.4413 12.3161 10.8787 12.8787C10.3161 13.4413 10 14.2044 10 15V27C10 27.7956 10.3161 28.5587 10.8787 29.1213C11.4413 29.6839 12.2044 30 13 30H27C27.7956 30 28.5587 29.6839 29.1213 29.1213C29.6839 28.5587 30 27.7956 30 27V15C30 14.2044 29.6839 13.4413 29.1213 12.8787C28.5587 12.3161 27.7956 12 27 12ZM28 27C28 27.2652 27.8946 27.5196 27.7071 27.7071C27.5196 27.8946 27.2652 28 27 28H13C12.7348 28 12.4804 27.8946 12.2929 27.7071C12.1054 27.5196 12 27.2652 12 27V20H28V27ZM28 18H12V15C12 14.7348 12.1054 14.4804 12.2929 14.2929C12.4804 14.1054 12.7348 14 13 14H15V15C15 15.2652 15.1054 15.5196 15.2929 15.7071C15.4804 15.8946 15.7348 16 16 16C16.2652 16 16.5196 15.8946 16.7071 15.7071C16.8946 15.5196 17 15.2652 17 15V14H23V15C23 15.2652 23.1054 15.5196 23.2929 15.7071C23.4804 15.8946 23.7348 16 24 16C24.2652 16 24.5196 15.8946 24.7071 15.7071C24.8946 15.5196 25 15.2652 25 15V14H27C27.2652 14 27.5196 14.1054 27.7071 14.2929C27.8946 14.4804 28 14.7348 28 15V18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSoS);
export default __webpack_public_path__ + "static/media/Calendar_SoS.8df008202a39e58a68d021144c5b3908.svg";
export { ForwardRef as ReactComponent };